module.exports = __webpack_public_path__ + "static/img/logo_499.c0c9e1c7.png";